
export class MappingEntry {
    id: string;
    merchantId : number;
    name : string;
    posExternalRef : string;
    sourceProductCode : string;
    targetProductCode : string;
    productDescription : string;
}
